


  import dep0 from "ember-resources/-embroider-implicit-modules.js";
  import dep1 from "@efdigital/ll-addon-auth/-embroider-implicit-modules.js";
  import dep2 from "@efdigital/ll-addon-coaching/-embroider-implicit-modules.js";
  import dep3 from "@efdigital/ll-addon-codemirror/-embroider-implicit-modules.js";
  import dep4 from "@efdigital/ll-addon-content/-embroider-implicit-modules.js";
  import dep5 from "@efdigital/ll-addon-data/-embroider-implicit-modules.js";
  import dep6 from "@efdigital/ll-addon-ui/-embroider-implicit-modules.js";
  import dep7 from "@ember-data/adapter/-embroider-implicit-modules.js";
  import dep8 from "@ember-data/debug/-embroider-implicit-modules.js";
  import dep9 from "@ember-data/graph/-embroider-implicit-modules.js";
  import dep10 from "@ember-data/json-api/-embroider-implicit-modules.js";
  import dep11 from "@ember-data/legacy-compat/-embroider-implicit-modules.js";
  import dep12 from "@ember-data/model/-embroider-implicit-modules.js";
  import dep13 from "@ember-data/request/-embroider-implicit-modules.js";
  import dep14 from "@ember-data/request-utils/-embroider-implicit-modules.js";
  import dep15 from "@ember-data/serializer/-embroider-implicit-modules.js";
  import dep16 from "@ember-data/store/-embroider-implicit-modules.js";
  import dep17 from "@ember/test-helpers/-embroider-implicit-modules.js";
  import dep18 from "@ember/test-waiters/-embroider-implicit-modules.js";
  import dep19 from "@embroider/legacy-inspector-support/-embroider-implicit-modules.js";
  import dep20 from "@embroider/router/-embroider-implicit-modules.js";
  import dep21 from "@glimmer/component/-embroider-implicit-modules.js";
  import dep22 from "@warp-drive/core/-embroider-implicit-modules.js";
  import dep23 from "@warp-drive/core-types/-embroider-implicit-modules.js";
  import dep24 from "@warp-drive/ember/-embroider-implicit-modules.js";
  import dep25 from "@warp-drive/json-api/-embroider-implicit-modules.js";
  import dep26 from "@warp-drive/legacy/-embroider-implicit-modules.js";
  import dep27 from "@warp-drive/utilities/-embroider-implicit-modules.js";
  import dep28 from "ember-cli-babel/-embroider-implicit-modules.js";
  import dep29 from "ember-data/-embroider-implicit-modules.js";
  import dep30 from "ember-modifier/-embroider-implicit-modules.js";
  import dep31 from "ember-page-title/-embroider-implicit-modules.js";
  import dep32 from "ember-qunit/-embroider-implicit-modules.js";
  import dep33 from "ember-source/-embroider-implicit-modules.js";
  import dep34 from "tracked-built-ins/-embroider-implicit-modules.js";
  import dep35 from "@embroider/macros/-embroider-implicit-modules.js";
  import dep36 from "@efdigital/ll-core-gtm/-embroider-implicit-modules.js";
  import dep37 from "@ember/optional-features/-embroider-implicit-modules.js";
  import dep38 from "ember-auto-import/-embroider-implicit-modules.js";
  import dep39 from "@glimmer/tracking/-embroider-implicit-modules.js";
  import dep40 from "ember-cli-deprecation-workflow/-embroider-implicit-modules.js";
  import dep41 from "ember-bootstrap/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
    dep7,
    dep8,
    dep9,
    dep10,
    dep11,
    dep12,
    dep13,
    dep14,
    dep15,
    dep16,
    dep17,
    dep18,
    dep19,
    dep20,
    dep21,
    dep22,
    dep23,
    dep24,
    dep25,
    dep26,
    dep27,
    dep28,
    dep29,
    dep30,
    dep31,
    dep32,
    dep33,
    dep34,
    dep35,
    dep36,
    dep37,
    dep38,
    dep39,
    dep40,
    dep41,
  {
  }
);
